var _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _path, _path2, _path3, _path4, _rect, _rect2, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _rect3, _rect4, _rect5, _rect6, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgWrong = function SvgWrong(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.44441,
    cy: 23.0826,
    rx: 1.44441,
    ry: 1.50662,
    fill: "url(#paint0_linear_73_3042)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 51.2952,
    cy: 28.6072,
    rx: 1.44441,
    ry: 1.50662,
    fill: "url(#paint1_linear_73_3042)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.8519,
    cy: 34.1314,
    rx: 0.962938,
    ry: 1.00441,
    fill: "url(#paint2_linear_73_3042)"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 47.9249,
    cy: 14.5444,
    rx: 0.962938,
    ry: 1.00441,
    fill: "url(#paint3_linear_73_3042)"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.7408,
    cy: 13.039,
    rx: 0.962938,
    ry: 1.00441,
    fill: "url(#paint4_linear_73_3042)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.5397 32.7086C44.6865 34.1862 46.9686 37.606 45.8353 41.9968",
    stroke: "#C4C4C4",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0813 43.8972C46.1487 43.6157 46.2432 42.8839 46.0813 42.2084",
    stroke: "#C4C4C4",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1755 42.2061C44.4536 42.2043 45.1566 42.1177 45.7436 41.7861",
    stroke: "#C4C4C4",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8029 43.6198C45.0073 43.4231 45.4712 42.8653 45.6911 42.2079",
    stroke: "#C4C4C4",
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 0.809876,
    height: 12.4895,
    rx: 0.404938,
    transform: "matrix(0.994614 0.103648 -0.0953453 0.995444 27.4497 44.4827)",
    fill: "#C4C4C4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 0.809952,
    height: 12.4884,
    rx: 0.404976,
    transform: "matrix(0.993441 -0.114349 0.105207 0.99445 34.1399 44.5772)",
    fill: "#C4C4C4"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.3913,
    cy: 31.0182,
    rx: 13.7619,
    ry: 14.3546,
    fill: "url(#paint5_linear_73_3042)"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 32.82,
    cy: 31.0182,
    rx: 13.7619,
    ry: 14.3546,
    fill: "url(#paint6_linear_73_3042)"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 32.82,
    cy: 31.0184,
    rx: 10.5238,
    ry: 10.9771,
    fill: "white"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 32.82,
    cy: 31.0184,
    rx: 10.5238,
    ry: 10.9771,
    fill: "url(#paint7_linear_73_3042)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 4.18838,
    height: 0.837676,
    rx: 0.418838,
    transform: "matrix(0.692047 -0.721853 0.692047 0.721853 27.5037 30.1832)",
    fill: "#1C1C1C"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 4.18838,
    height: 0.837676,
    rx: 0.418838,
    transform: "matrix(-0.692047 -0.721853 0.692047 -0.721853 30.4019 30.7874)",
    fill: "#1C1C1C"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 4.18838,
    height: 0.837676,
    rx: 0.418838,
    transform: "matrix(0.692047 -0.721853 0.692047 0.721853 34.7893 30.1832)",
    fill: "#1C1C1C"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 4.18838,
    height: 0.837676,
    rx: 0.418838,
    transform: "matrix(-0.692047 -0.721853 0.692047 -0.721853 37.6875 30.7874)",
    fill: "#1C1C1C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9866 36.0837C30.931 34.8093 33.3866 33.0252 35.6532 36.0837",
    stroke: "#1C1C1C",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9998 17.0878C20.6346 16.5508 21.7138 15.0665 20.952 13.4259C20.4759 12.4006 19.9998 10.7894 20.952 9.91052",
    stroke: "#C4C4C4",
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8572 17.0878C42.492 16.5508 43.5713 15.0665 42.8094 13.4259C42.3333 12.4006 41.8572 10.7894 42.8094 9.91052",
    stroke: "#C4C4C4",
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9285 13.2883C31.5633 12.5932 32.6425 10.6724 31.8807 8.54936C31.4046 7.22246 30.9285 5.13734 31.8807 4",
    stroke: "#C4C4C4",
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2975 35.2419C17.1506 36.7195 14.8686 40.1393 16.0019 44.5301",
    stroke: "#C4C4C4",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7561 46.4305C15.6887 46.149 15.5942 45.4172 15.7561 44.7417",
    stroke: "#C4C4C4",
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6617 44.7394C17.3836 44.7376 16.6805 44.651 16.0935 44.3194",
    stroke: "#C4C4C4",
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0343 46.152C16.8298 45.9552 16.366 45.3975 16.146 44.74",
    stroke: "#C4C4C4",
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_73_3042",
    x1: 8.44441,
    y1: 21.576,
    x2: 8.44441,
    y2: 24.5892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#868686"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_73_3042",
    x1: 51.2952,
    y1: 27.1006,
    x2: 51.2952,
    y2: 30.1138,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#868686"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_73_3042",
    x1: 10.8519,
    y1: 33.127,
    x2: 10.8519,
    y2: 35.1358,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#868686"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_73_3042",
    x1: 47.9249,
    y1: 13.54,
    x2: 47.9249,
    y2: 15.5488,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#868686"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_73_3042",
    x1: 13.7408,
    y1: 12.0345,
    x2: 13.7408,
    y2: 14.0434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#868686"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_73_3042",
    x1: 30.3913,
    y1: 16.6636,
    x2: 30.3913,
    y2: 45.3728,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#868686"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_73_3042",
    x1: 43.822,
    y1: 31.1172,
    x2: 22.6374,
    y2: 31.1172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2E2E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_73_3042",
    x1: 32.82,
    y1: 20.0413,
    x2: 32.7418,
    y2: 54.9721,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ADADAD"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWrong, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/wrong.c6d9a7e7.svg";
export { ForwardRef as ReactComponent };